import React, { useState, useEffect } from "react";
import { Field, Form, Formik, FormikHelpers as FormikActions, FormikProps } from "formik";
import SelectAsyncPaginate from './PhenotypeSelectForGene';
import { useRouter } from 'next/router';
import Router from 'next/router';
import axios from 'axios';
import { Button, Stack, Box, Heading, HStack, VStack, useColorModeValue } from "@chakra-ui/react"
import useSWR, { SWRConfig } from "swr";

const MultiSelectForm = (instanceId) => {
  const [conditionOptions, setConditionOptions] = useState([])
  const [myQuery, setMyQuery] = useState([])
  
  const router = useRouter()
  const borderColor = useColorModeValue("gray.200", "neutral.900")
  const buttonColor = useColorModeValue('gray.600', 'gray.600');
  const buttonBG = useColorModeValue('cyan.300', 'cyan.300');

  const fetcher = (url, token) =>
  fetch(url, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json', token }),
    credentials: 'same-origin',
  }).then((res) => res.json())

  const fetchQueryData = async() => {
    var results = []
    var phenotypes = []

    // const queryString = typeof router.query.phenotype == 'object' ? router.query.phenotype.map(phenotype => "&phenotype=" + phenotype).join('') : `phenotype=${router.query.phenotype}`
    router.query.phenotype ? typeof(router.query.phenotype) == 'string' ? phenotypes.push(router.query.phenotype) : phenotypes=router.query.phenotype: null
    // console.log("phenotypessssss:");
    // console.log(phenotypes);
    // const { data, error } = useSWR(['/api/getPhenotypesFilter'], fetcher)
    // const response = await axios.get(`http://127.0.0.1:8000/api/phenotypes_filter?${queryString}`)

    }

  useEffect(()=>{
    if(router.query.phenotype) {
    fetchQueryData()
  }

  }, [router])

  const onSubmit = (values, actions) => {
    // alert(JSON.stringify(values, null, 2));
    router.push({
      pathname: '/genes',
      query: {...values, page: 1 },
  });
  actions.setSubmitting(false);
  };

  const onReset = (values, actions) => {
    // alert(JSON.stringify(values, null, 2));
    setConditionOptions([])
    router.push({
      pathname: router.pathname,
      query: {...values, page: 1 },
  });
  actions.setSubmitting(false);
  }

  const renderForm = (formikBag) => (
    <Form>
      <Field
        className="phenotype-select"
        name="phenotype"
        options={conditionOptions}
        component={SelectAsyncPaginate}
        placeholder="Search or select phenotypes"
        isMulti={true}
        isClearable={true}
        isSearchable={true}
        query={myQuery}
        instanceId={instanceId}
      />

      <Stack spacing={2} direction="row" align="center" mt={3}>
      <Button 
        colorScheme="gray" 
        type="submit" 
        borderRadius="12"
        onClick={formikBag.handleReset}
        disabled={!formikBag.dirty || formikBag.isSubmitting}
        size="sm"
      >
        Reset
      </Button>
      <Button type="submit" size="sm" color={buttonColor} bg={buttonBG} borderRadius={12} _hover={{bg: "gray.600", color: "gray.50"}}>
        Apply Filters
      </Button>
      </Stack>
    </Form>
  );

  return (
    <Formik
      initialValues={{ phenotype: [] }}
      onSubmit={onSubmit}
      onReset={onReset}
      enableReinitialize={true}
    >
      {props => (
        renderForm(props)
      )}
    </Formik>
  );
};

const GeneFilters = (instanceId) => {
  return (
      <>
      <Box>
      <Heading as="h5" fontSize={14} size="s" mb="2" fontWeight="normal">Filter by Phenotype</Heading>
      <MultiSelectForm instanceId={instanceId}/>
      </Box>
      </>
  );
};

export default GeneFilters;

